/* eslint-disable @typescript-eslint/no-explicit-any */

import { api, ApiResponse } from '@/api/api';
import { isAxiosError } from 'axios';
import { INBOX_URLS } from '@/api/url';

export interface GetInboxParams {
  unread: boolean;
  page: number;
  limit: number;
}

export interface GetInboxResponse {
  messages: Inbox[];
  current_page: number;
  total_count: number;
  limit: number;
}

export const apiGetInbox = async ({
  params
}: {
  params: GetInboxParams;
}): Promise<ApiResponse<GetInboxResponse>> => {
  try {
    const response = await api.get<ApiResponse<GetInboxResponse>>(INBOX_URLS.GET_ALL, { params });
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export interface GetUnreadCountResponse {
  unread_count: number;
}

export const apiGetUnreadCount = async (): Promise<ApiResponse<GetUnreadCountResponse>> => {
  try {
    const response = await api.get<ApiResponse<GetUnreadCountResponse>>(INBOX_URLS.UNREAD_COUNT);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export interface MarkInboxAsReadPayload {
  is_read: boolean;
}

export const apiMarkInboxAsRead = async ({
  inboxId,
  payload
}: {
  inboxId: string;
  payload: MarkInboxAsReadPayload;
}): Promise<ApiResponse<void>> => {
  try {
    const response = await api.put<ApiResponse<void>>(INBOX_URLS.MARK_AS_READ(inboxId), payload);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export const apiMarkAllInboxAsRead = async (): Promise<ApiResponse<void>> => {
  try {
    const response = await api.post<ApiResponse<void>>(INBOX_URLS.MARK_ALL_READ);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export const apiDeleteInbox = async ({
  inboxId
}: {
  inboxId: string;
}): Promise<ApiResponse<void>> => {
  try {
    const response = await api.delete<ApiResponse<void>>(INBOX_URLS.DELETE(inboxId));
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};
